var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"fade"}},[_c('router-view',{attrs:{"userInfo":_vm.userInfo,"questionList":_vm.questionList,"reportList":_vm.reportList},on:{"getData":_vm.getData}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }